var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgMedical = props => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M19.75 9H15V4.25A1.25 1.25 0 0 0 13.75 3h-3.5A1.25 1.25 0 0 0 9 4.25V9H4.25A1.25 1.25 0 0 0 3 10.25v3.46A1.25 1.25 0 0 0 4.25 15H9v4.79A1.25 1.25 0 0 0 10.25 21h3.5A1.25 1.25 0 0 0 15 19.75V15h4.75A1.25 1.25 0 0 0 21 13.71v-3.46A1.25 1.25 0 0 0 19.75 9Z"
})));
export default SvgMedical;